'use es6';

import { createContext } from 'react';
import StorefrontFilters from '../records/StorefrontFilters';
export default /*#__PURE__*/createContext({
  filters: new StorefrontFilters(),
  clearFilters: () => {},
  isAllCategories: false,
  pushFilters: () => {},
  updateAllFilters: () => {},
  updateFilter: () => {}
});